export const PRIMARY_FONT = {
  REGULAR: "RethinkSans-Regular",
  MEDIUM: "RethinkSans-Medium",
  SEMIBOLD: "RethinkSans-SemiBold",
};
